import { MAP_FALLBACK_POSITION } from '../constants/config';
import { googleCoordinates } from './googleCoordinates';
export const getDefaultMapCenter = ({ initialCoordinates, fixedCoordinates, userPosition }) => {
    if (fixedCoordinates)
        return googleCoordinates(fixedCoordinates);
    if (initialCoordinates)
        return googleCoordinates(initialCoordinates);
    if (userPosition)
        return userPosition;
    return googleCoordinates(MAP_FALLBACK_POSITION);
};
